"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../BaseComponent");
var ProductCard_1 = require("./ProductCard");
var ProductFilter = /** @class */ (function (_super) {
    __extends(ProductFilter, _super);
    function ProductFilter($view) {
        var _this = _super.call(this, $view) || this;
        _this.initVars();
        _this.initEvents();
        _this.initMods();
        _this.updateContentFromHash();
        return _this;
    }
    ProductFilter.prototype.initVars = function () {
        /**
         * Differents templates reloadable
         * @type {string}
         */
        this.TEMPLATE_PRODUCTS = 'products',
            /**
             * Containers
             * @type {string}
             */
            this.productsContainerId = '#products-container',
            this.filtersContainerId = '#section-products',
            /**
             * Current selected filters
             * @type {{}}
             */
            this.selectedFilters = {},
            /**
             * Full hash value (with hashtag #)
             * @type {string}
             */
            this.hashCurrent = null,
            /**
             * Hash value without # (hashtag)
             * Used as key in javascript object to store/recover cache
             * @type {string}
             */
            this.hashKey = null,
            /**
             * To store already retrieved content
             * @type {{object}}
             */
            this.cache = {},
            /**
             * Default product filters values
             * @type {number}
             */
            this.productsPage = 1,
            this.productsQuantity = 12,
            this.productsOrder = 1,
            /**
             * Regex
             */
            this.productsPageRegex = /\#?\&?p=(\d+)/i,
            this.productsQuantityRegex = /\#?\&?q=(\d+)/i,
            this.productsOrderRegex = /\#?\&?t=(\d+)/i;
    };
    ProductFilter.prototype.initMods = function () {
        this.$view.find('.mod-title').on('click', function (e) {
            $(e.target).parents(".block-module").find(".mod-content").toggleClass('hidden');
            $(e.target).toggleClass("active");
        });
    };
    /**
     * Return jQuery container
     * @param containerId
     * @returns {*|jQuery|HTMLElement}
     */
    ProductFilter.prototype.getContainer = function (containerId) {
        var $container = $(containerId);
        if ($container !== undefined && $container.length > 0)
            return $container;
        else {
            return undefined;
            console.error('Container not found - Id : ' + containerId);
        }
    };
    ProductFilter.prototype.getProductsContainer = function () {
        return this.getContainer(this.productsContainerId);
    };
    ProductFilter.prototype.getFiltersContainer = function () {
        return this.getContainer(this.filtersContainerId);
    };
    /**
     * Analyse hash, and update content with hash params
     */
    ProductFilter.prototype.updateContentFromHash = function () {
        this.hashCurrent = window.location.hash;
        this.hashKey = this.hashCurrent.replace(/^#/, '');
        // Update current page from current hash
        this.updatePaginationFromHash();
        this.updateQuantityFromHash();
        this.updateOrderFromHash();
        this.getCurrentProductsContent();
    };
    /**
     * Update CurrentPage using current URL hash
     */
    ProductFilter.prototype.updatePaginationFromHash = function () {
        var match;
        if (match = this.productsPageRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.productsPage = match[1];
        }
    };
    /**
     * Update Quantity using current URL hash
     */
    ProductFilter.prototype.updateQuantityFromHash = function () {
        var match;
        if (match = this.productsQuantityRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.productsQuantity = match[1];
        }
    };
    /**
     * Update Order using current URL hash
     */
    ProductFilter.prototype.updateOrderFromHash = function () {
        var match;
        if (match = this.productsOrderRegex.exec(this.hashCurrent)) {
            // Update the products current page
            this.productsOrder = match[1];
        }
    };
    /**
     * Retrieve the content adapted to the current selected filters
     */
    ProductFilter.prototype.getCurrentProductsContent = function (templates) {
        if (templates === void 0) { templates = null; }
        if (templates === null) {
            templates = [this.TEMPLATE_PRODUCTS];
        }
        // Check if cache content exist
        if (this.isCurrentFilterCached(templates)) {
            // If it does, then show the cached content
            this.updateContent();
        }
        else {
            // If not, then request for content and cache it
            this.sendFilterRequest(templates);
        }
    };
    /**
     * Check if system has already load the current requested hashKey
     * @returns {boolean}
     */
    ProductFilter.prototype.isCurrentFilterCached = function (templates) {
        var isCached = true;
        if (!this.cache.hasOwnProperty(this.hashKey)) {
            this.cache[this.hashKey] = {};
            isCached = false;
        }
        $.each(this.cache[this.hashKey], function (key, item) {
            if (isCached === false)
                return;
            isCached = $.inArray(key, templates) > -1;
        });
        return isCached;
    };
    /**
     * Save retrieved data into cache object
     * @param content
     * @param templates
     */
    ProductFilter.prototype.pushCachedData = function (content, templates) {
        if (!this.cache.hasOwnProperty(this.hashKey)) {
            this.cache[this.hashKey] = {};
        }
        var $this = this;
        $.each(templates, function (key, value) {
            if (content.templates.hasOwnProperty(value)) {
                $this.cache[$this.hashKey][value] = content.templates[value];
            }
        });
    };
    /**
     * Update the content of the page with current hashKey
     */
    ProductFilter.prototype.updateContent = function () {
        var _this = this;
        var data;
        if (data = this.cache[this.hashKey]) {
            $.each(data, function (key, item) {
                var $container = undefined;
                if (key === _this.TEMPLATE_PRODUCTS) {
                    $container = _this.getProductsContainer();
                }
                if (typeof $container !== 'undefined') {
                    $container.empty().append($(item));
                }
            });
        }
        // Reload listener on favourites stars click
        // App.initFavourites();
    };
    /**
     * Update hash class params and propagate the new hash into the URL
     */
    ProductFilter.prototype.updateHash = function () {
        var _this = this;
        this.hashKey = '1';
        /*
         * Hash for products
         */
        this.hashKey += '&p=' + this.productsPage;
        this.hashKey += '&q=' + this.productsQuantity;
        this.hashKey += '&t=' + this.productsOrder;
        $.each(this.selectedFilters, function (key, filterValues) {
            // @ts-ignore
            _this.hashKey += '&f' + key + '=' + filterValues.join(',');
        });
        window.location.hash = '#' + this.hashKey;
    };
    /**
     * Build current url
     * @returns {string}
     */
    ProductFilter.prototype.buildUrl = function () {
        var url = window.location.origin + window.location.pathname;
        var search = window.location.search;
        if (!search) {
            search = '?1';
        }
        url += search;
        return url;
    };
    /**
     * Send request with template required to response,
     * filters, pages, orders, quantities
     * @param templates Templates required to json response
     */
    ProductFilter.prototype.sendFilterRequest = function (templates) {
        var _this = this;
        var $container;
        $.each(templates, function (key, value) {
            if (value === _this.TEMPLATE_PRODUCTS) {
                $container = _this.getProductsContainer();
            }
        });
        if (typeof $container !== 'undefined') {
            $container.empty().append($('.loader-template').clone().children());
        }
        $.ajax({
            url: this.buildUrl(),
            data: {
                templates: templates,
                p: this.productsPage,
                q: this.productsQuantity,
                t: this.productsOrder,
                filters: this.selectedFilters
            },
            success: function (data) {
                // Save retrieved data to cache array
                _this.pushCachedData(data, templates);
                // Then update content
                _this.updateContent();
                // Transfert des données à la datalayer de GTM s'il y en a
                _this.processGtmData(data);
                // reload product card events
                document.querySelectorAll('[data-mount="ProductCard"]').forEach(function (card) {
                    var productCard = new ProductCard_1.default($(card));
                    productCard.initEvents();
                });
            }
        });
    };
    /**
     * Transfert des données GTM à la datalayer si elles sont transmises
     * @param data
     */
    ProductFilter.prototype.processGtmData = function (data) {
        // @ts-ignore
        if (typeof dataLayer !== 'undefined' && data.gtm !== undefined) {
            // Envoi des données à GTM
            Object.keys(data.gtm).forEach(function (k) {
                // @ts-ignore
                dataLayer.push(data.gtm[k]);
            });
        }
        // Ancienne méthode sur Courant mais ne fonctionne pas avec l'import fait en début de fichier
        // HegydGtm n'est pas détecté et on a un undefined
        //if ( data.hasOwnProperty('gtm')
        //    && HegydGtm !== undefined
        //    && typeof HegydGtm.pushToDatalayer === "function" ) {
        //    HegydGtm.pushToDatalayer(data.gtm);
        //}
    };
    /**
     * Update hash url and products contents
     * @param templates
     */
    ProductFilter.prototype.refreshHashAndContent = function (templates) {
        this.updateHash();
        this.getCurrentProductsContent(templates);
    };
    /**
     * Init all page events
     */
    ProductFilter.prototype.initEvents = function () {
        this.initBlockEvents(this.TEMPLATE_PRODUCTS);
        this.initBlockFiltersEvents([this.TEMPLATE_PRODUCTS]);
    };
    /**
     * Init products events
     *
     * @param template
     * @returns {boolean}
     */
    ProductFilter.prototype.initBlockEvents = function (template) {
        var _this = this;
        var $container = undefined;
        var self = this;
        if (template === this.TEMPLATE_PRODUCTS) {
            $container = this.getProductsContainer();
        }
        if (typeof $container === 'undefined') {
            return false;
        }
        var templates = [template];
        $container.on('click', '.pagination a', function (e) {
            e.preventDefault();
            var page = $(e.target).attr('href').split('page=')[1];
            if (template === _this.TEMPLATE_PRODUCTS) {
                _this.productsPage = page;
            }
            _this.refreshHashAndContent(templates);
            window.scrollTo(0, 160);
            return false;
        })
            .on('change', '.filter-order', function (e) {
            e.preventDefault();
            var order = $(e.target).val();
            if (template === _this.TEMPLATE_PRODUCTS) {
                _this.productsOrder = order;
            }
            _this.refreshHashAndContent(templates);
            return false;
        })
            .on('change', '#slider-from, #slider-to', function (e) {
            e.preventDefault();
            var quantity = $(e.target).val();
            if (template === _this.TEMPLATE_PRODUCTS) {
                _this.productsPage = 1;
                _this.productsQuantity = quantity;
            }
            _this.refreshHashAndContent(templates);
            return false;
        })
            .on('change', '.filter-quantity', function (e) {
            e.preventDefault();
            var quantity = $(e.target).val();
            _this.productsPage = 1;
            _this.productsQuantity = quantity;
            _this.refreshHashAndContent(templates);
            return false;
        });
    };
    ProductFilter.prototype.initBlockFiltersEvents = function (templates) {
        var _this = this;
        var $filterContainer = this.getFiltersContainer();
        if (typeof $filterContainer !== 'undefined') {
            $filterContainer.off('click');
            $filterContainer.on('change', 'input[type="checkbox"][data-filter]', function (e) {
                var $el = $(e.target);
                _this.clearFilters([_this.TEMPLATE_PRODUCTS]);
                _this.manageFilters($el.data('filter'), $el.val());
                _this.refreshHashAndContent(templates);
            }).on('change', 'select[data-filter]', function (e) {
                var $el = $(e.target);
                var filterId = $el.data('filter');
                var value = $el.val();
                _this.deleteFilter(filterId);
                // Si la valeur sélectionnée est vide on ne rajoute pas le filtre
                if (value !== undefined && value !== 'null' && value !== '') {
                    _this.manageFilters(filterId, $el.val());
                }
                _this.refreshHashAndContent(templates);
                // @ts-ignore
            }).on('keyup', 'input[type="number"][data-input="price"]', $.debounce(800, function () {
                _this.filterByPrices();
            }))
                .on('change', 'input[type="radio"][data-filter]', function (e) {
                var $el = $(e.target);
                _this.clearFilters([_this.TEMPLATE_PRODUCTS]);
                _this.manageFilters($el.data('filter'), $el.val(), true);
                _this.refreshHashAndContent(templates);
            });
            $filterContainer.on('click', '.reset-all-filters', function (e) {
                e.preventDefault();
                _this.selectedFilters = {};
                _this.clearFilters();
                _this.updateHash();
                _this.updateContentFromHash();
                $('input[type="number"]').val('');
                $('input[type=checkbox]').prop('checked', false);
                $('input[type=radio]').prop('checked', false);
                var templates = [_this.TEMPLATE_PRODUCTS];
                _this.getCurrentProductsContent(templates);
                _this.refreshHashAndContent(templates);
            });
        }
    };
    ProductFilter.prototype.manageFilters = function (filterId, filterValue, renew) {
        if (renew === void 0) { renew = null; }
        if (!this.selectedFilters.hasOwnProperty(filterId) || renew === true) {
            this.selectedFilters[filterId] = [];
        }
        var index;
        if ((index = $.inArray(filterValue, this.selectedFilters[filterId])) > -1) {
            this.selectedFilters[filterId].splice(index, 1);
            if (this.selectedFilters[filterId].length == 0) {
                delete this.selectedFilters[filterId];
            }
        }
        else {
            this.selectedFilters[filterId].push(filterValue);
        }
    };
    ProductFilter.prototype.clearFilters = function (templates) {
        if (templates === void 0) { templates = null; }
        if (templates) {
            templates = [this.TEMPLATE_PRODUCTS];
        }
        if ($.inArray(this.TEMPLATE_PRODUCTS, templates) > -1) {
            this.productsPage = 1;
        }
    };
    ProductFilter.prototype.deleteFilter = function (filterId) {
        filterId = parseInt(filterId);
        if (isNaN(filterId)) {
            return;
        }
        if (this.selectedFilters.hasOwnProperty(filterId)) {
            delete this.selectedFilters[filterId];
        }
    };
    ProductFilter.prototype.filterByPrices = function () {
        var $item = $('#price-range');
        var filterId = $item.data('filter');
        var min = 0;
        if ($('#slider-from').val()) {
            min = parseFloat($('#slider-from').val().toString().replace(/\D/g, ''));
        }
        if (!$('#slider-to').val()) {
            return;
        }
        else {
            var max = parseFloat($('#slider-to').val().toString().replace(/\D/g, ''));
        }
        this.deleteFilter(filterId);
        /*
         Si les valeurs sélectionnées sont les valeurs initiales,
         on ne les rajoutes pas
          */
        if (min === $item.data('filter-min') && max === $item.data('filter-max')) {
            this.refreshHashAndContent([this.TEMPLATE_PRODUCTS]);
        }
        else {
            if (min === max) {
                max = min + 1;
            }
            this.manageFilters(filterId, min);
            this.manageFilters(filterId, max);
        }
        $('.min-label', $item.parent()).val(min + $item.data('filter-unit'));
        $('.max-label', $item.parent()).val(max + $item.data('filter-unit'));
        this.clearFilters([this.TEMPLATE_PRODUCTS]);
        this.refreshHashAndContent([this.TEMPLATE_PRODUCTS]);
    };
    return ProductFilter;
}(BaseComponent_1.default));
exports.default = ProductFilter;
;
